import { memo } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { IRootPros, ITitleProps } from './interface';

export const Root = memo<IRootPros>(({ children, ...props }) => {
  return (
    <Card component="section" sx={{ breakInside: 'avoid' }} {...props}>
      <CardContent>{children}</CardContent>
    </Card>
  );
});

export const Title = memo<ITitleProps>(
  ({ title = 'Gráfico de Rentabilidade', description, UiTooltip }) => {
    return (
      <Box mb={1}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Typography variant="h2">{title}</Typography>
          {UiTooltip}
        </Box>

        {description && (
          <Typography component="span" variant="body1">
            {description}
          </Typography>
        )}
      </Box>
    );
  }
);

export const SpaceBox = ({ children }) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      mb={1}
    >
      {children}
    </Box>
  );
};

export * from './components/benchmarks';
export * from './components/last-update';
export * from './components/profit-chart';
export * from './components/render-last-value';
export * from './constants';
